import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { navLinks, siteMeta } from "../data/siteContent";

function SiteFooter() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          <Col lg={4} md={6}>
            <div className="site-footer__brand">
              <h3>{siteMeta.churchName}</h3>
              <p className="site-footer__tagline">{siteMeta.tagline}</p>
              <p>
                A community of believers gathered by grace, shaped by Scripture,
                centered on Christ, and sent with the gospel.
              </p>
            </div>
          </Col>
          <Col lg={2} md={6}>
            <h4>Explore</h4>
            <ul className="site-footer__links">
              {navLinks.slice(0, 5).map((item) => (
                <li key={item.path}>
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={3} md={6}>
            <h4>Church Life</h4>
            <ul className="site-footer__links">
              <li>
                <Link to="/ministries">Ministries</Link>
              </li>
              <li>
                <Link to="/resources">Resources</Link>
              </li>
              <li>
                <Link to="/visit">Plan Your Visit</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/blog">Solid Joy</Link>
              </li>
            </ul>
          </Col>
          <Col lg={3} md={6}>
            <h4>Visit Us</h4>
            <ul className="site-footer__meta">
              <li>{siteMeta.serviceTime}</li>
              <li>{siteMeta.address}</li>
              <li>{siteMeta.location}</li>
              <li>{siteMeta.phone}</li>
              <li>{siteMeta.email}</li>
            </ul>
            <div className="site-footer__socials">
              <a href={siteMeta.youtube} target="_blank" rel="noreferrer">
                YouTube
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                Instagram
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                Facebook
              </a>
            </div>
          </Col>
        </Row>
        <div className="site-footer__bottom">
          <p>© 2026 Reformed Missional Church. All rights reserved.</p>
          <p>For the glory of God alone.</p>
        </div>
      </Container>
    </footer>
  );
}

export default SiteFooter;
